import { render, staticRenderFns } from "./formulario_edit_show.vue?vue&type=template&id=535469b8&scoped=true"
import script from "./formulario_edit_show.vue?vue&type=script&lang=js"
export * from "./formulario_edit_show.vue?vue&type=script&lang=js"
import style0 from "./formulario_edit_show.vue?vue&type=style&index=0&id=535469b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535469b8",
  null
  
)

export default component.exports